// @flow

import { getApi, postRaw } from './api.core'

export const getRoomType = params => getApi(`api/room-type/`, params)
export const createRoomType = params => postRaw(`api/room-type/batch/`, params)
